import Progressbar from "src/components/Progressbar";
import PanelLayout from "src/Layout/PanelLayout";
import Title from "src/components/Title";
import { useEffect, useState } from "react";
import Button from "src/components/Form/Button";
import Subheading from "src/components/Subheading";
import FormCheckbox from "src/components/Form/FormCheckbox";
import AbadRavanShenasi from "src/components/Form/AbadRavanShenasi";
import usePersistantState from "src/hooks/usePersistantState";
import { useLocation } from "react-router-dom";
import { post } from "src/services/HttpClient";
import { notify } from "src/services/Notification/Notification";



export default function JobAnalysisPage6({ handleStep, handleStepDown }) {

    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const jobId = params.get("id");

    const [alayeghVaReghbatShoghli, setAlayeghVaReghbatShoghli] = usePersistantState("alayeghVaReghbatShoghli", {
        "واقع گرایی": {
            value: {},
            desc: "(این افراد دوست دارند با ماشین ها و ابزارآلات کار کنند و عموما از فعالیتهای اجتماعی مانند تدریس و اطلاع رسانی به دیگران گریزانند)"
        },
        "كنكاشگری": {
            value: {},
            desc: "(این افراد دوست دارند مطالعه کنند و به حل مسائل ریاضی و علوم بپردازند، عموما از هدایت و تشویق و ترغیب دیگران گریزانند)"
        },
        "اجتماعی": {
            value: {},
            desc: "(این افراد دوست دارند به دیگران کمک کند و به فعالیتهایی نظیر تدریس، مشاوره، پرستاری و آگاهی به دیگران علاقمندند عموما از فعالیتهای مانند کار با ماشین آلات و ابزار گریزانند)"
        },
        "كارآفرینی": {
            value: {},
            desc: "(این افراد دوست دارند سایر افراد را رهبری کرده و آنها را تشویق و ترغیب به انجام اعمالی نماید، علاقمندند ایده هایی را به دیگران ارائه دهند یا چیزهایی را به دیگران بفروشند. عموما از فعالیتهایی که مستلزم مشاهده دقیق و علمی و یا تفکر تحلیلی است گریزان هستند)"
        },
        "قاعده گرایی": {
            value: {},
            desc: "(دوست دارند با اعداد و مستندات کار کنند و یا با ماشین آلاتی که دارای نظم و ترتیب خاصی هستند. عموما از فعالیتهای مبهم و بدون ساختار گریزان است)"
        },
        "هنرگرایی": {
            value: {},
            desc: "(انجام کارهای خلاق مانند هنر، نمایش، موزیک و نوشتن و مطالعه رمان را دوست دارند، عموما از کارهای نظم یافته یا تکراری گریزان هستند)"
        },
    })


    const [panjVizhegiBarezRaftari, setPanjVizhegiBarezRaftari] = usePersistantState("panjVizhegiBarezRaftari", {
        "ثبات هیجانی": {
            value: {},
            desc: "(معرف نداشتن مشکلات روان شناختی و سلامت و  بهداشت روانی است نظیر نداشتن اضطراب، پرخاشگری، افسردگی، کنترل امیال و آرزوها)"
        },
        "برونگرایی": {
            value: {},
            desc: "(این ویژگی به رفتارهای بین فردی و رشد اجتماعی مرتبط با فعالیتهای اجتماعی معطوف است . این صفت یکی از نشانه های رفتار اجتماعی است)"
        },
        "گشودگی یا انعطاف پذیری": {
            value: {},
            desc: "(این صفت بر اساس زمینه های تجربی که فرد در آن منعطف است طراحی شده و بیانگر تمایل فرد به کسب تجارب تازه می باشد)"
        },
        "توافق پذیری": {
            value: {},
            desc: "(این صفت را می توان با ویژگی های مثبت انسان دوستی و همکاری های گروهی در محیط کار مترادف دانست که بیانگر میزان سازگاری و همرنگی در محیط کار می باشد)"
        },
        "وجدان کاری": {
            value: {},
            desc: "(این صفت یکی از ویژگی های کارمند یا کارگر خوب است که مفهوم وجدان کاری را نیز در بر می گیرد)"
        },
    })

    const [hooshChandgane, setHooshChandgane] = usePersistantState("hooshChandgane", {
        "هوش زبانی/ کلامی": {
            value: {},
            desc: "(عبارت است از توانایی کاربرد مؤثّر زبان مادری و احتمالاً سایر زبان‌ها به صورت شفاهی یا نوشتاری)"
        },
        "هوش منطقی/ ریاضی": {
            value: {},
            desc: "(شامل توانایی کشف الگوها، دلایل قیاسی و تفکر منطقی است)"
        },
        "هوش مکانی (دیداری/ فضایی)": {
            value: {},
            desc: "(عبارت است از توانایی دستکاری و تغییر و تبدیل بر روی درک اولیۀ فرد و توانایی خلق مجدد جنبه‌ای از ادراک نخستین، حتی در نبود فیزیک مورد مربوط)"
        },
        "هوش حرکتی/ جسمانی": {
            value: {},
            desc: "(عبارت است از استفاده از بدن و سیستم‌های ادراکی و مکانیکی مغز در حلّ مسائل، و شامل توانایی فهم دنیا از طریق بدن می‌باشد)"
        },
        "هوش میان فردی (ادراک اجتماعی)": {
            value: {},
            desc: "(شامل توانایی فهم و درک تفاوت میان روحیات، احساس و هیجانات و فهم افراد است، توانایی برقراری ارتباط و تعامل با سایر افراد و گروهها را هوش میان فردی گویند)"
        },
        "هوش درون فردی (ادراک درونی)": {
            value: {},
            desc: "(عبارت است از توانایی فهم و بیان کردن احساسات درونی، دانستن این که چه کسی هستید، چه کارهایی می‌توانید انجام دهید)"
        },
        "هوش موسیقیایی": {
            value: {},
            desc: "(درک و شنیدن تُن و ریتم و طرح‌های موزیکال و زیر و بم صدا و آهنگ)"
        },
        "هوش طبیعت‌گرا (هوش محیطی)": {
            value: {},
            desc: "(توانایی فهم نمادهای طبیعی و احترام و حساسیت نسبت به توازنی که به ما امکان ادامه زندگی می‌دهد)"
        },
    })
    return (
        <PanelLayout>
            <Title title="تجزیه و تحلیل شغل" />
            <Progressbar activePart={7} handleStep={handleStep} />
            <div className="bg-white p-10 mx-28 shadow-lg border border-gray-200 rounded-lg">

                <Subheading title="علایق و رغبت های شغلی" isFirst={true} />
                <FormCheckbox state={alayeghVaReghbatShoghli} setState={setAlayeghVaReghbatShoghli} gozineType={2} maxFour={2} />





                <Subheading title="پنج ویژگی بارز رفتاری" />
                <FormCheckbox state={panjVizhegiBarezRaftari} setState={setPanjVizhegiBarezRaftari} gozineType={2} />



                <Subheading title="هوش های چندگانه" />
                <FormCheckbox state={hooshChandgane} setState={setHooshChandgane} gozineType={2} />





                <Subheading title="کدامیک از ویژگی های زوجی زیر برای این شغل بیشتر مناسب است؟" />
                <div className="flex justify-center w-full my-6">
                    <img src="assets/img/mbti.png" />
                </div>
                <AbadRavanShenasi />





                <div className="flex justify-center items-center relative mt-10 z-50">
                    <Button isPrevious={true} title="مرحله قبل" direction="center" handleClick={(event) => handleStepDown()} color="#f9b302" />
                    <Button title="ثبت اطلاعات و تکمیل" direction="center" handleClick={async (event) => {
                        handleStep()
                        const result = await post(`/jobs/${jobId}`, {
                            analyzeStatus: "1",
                        });
                        if (result && result.success) {
                            notify("وضعیت شغل به تحلیل شده تغییر پیدا کرد", "success")
                        }else{
                            notify("در ذخیره سازی اطلاعات خطایی رخ داد", "error")
                        }
                    }} />
                </div>
            </div>



        </PanelLayout>
    )
}